// extracted by mini-css-extract-plugin
module.exports = {"card":"brandCard_card__2vWja","image":"brandCard_image__1g6Hm"};